import { getProductTableListFetch, deleteUserTableItemFetch, updateProductTableItemFetch, addProductTableItemFetch } from "../../api/api"
import { osTypeFu } from "../../config/table_comlun"
const state = {
  userList: [],
  total: 0,
  current_page: 1
}

const actions = {
  async getProductTableList({ commit }, { param, cb }) {
    try {
      const data = await getProductTableListFetch(param)
      data.products.map(v => {
        v.popuStatus = v.popuStatus == 1 ? true : false
        v.osType = osTypeFu(v.osType)
      })
      cb(data.products)
      commit('setUserTableList', data)

    } catch (e) {
      throw new Error(e)
    }

  },
  async deleteUserTableItem({ commit }, { param, cb }) {
    try {
      const data = await deleteUserTableItemFetch({ id: param });
      cb(data.code)
      commit('')
    } catch (e) {
      throw new Error(e)
    }

  },
  async updateProductTableItem({ commit }, { param, cb }) {
    try {
      const data = await updateProductTableItemFetch({ data: param })
      commit('')
      cb(data)
    } catch (e) {
      throw new Error(e);
    }
  },
  async addProductTableItem({ commit }, { param, cb }) {
    try {
      const data = await addProductTableItemFetch({ data: param })
      commit('')
      cb(data)
    } catch (e) {
      throw new Error(e);
    }
  },
  getCurrentPage({ commit }, param) {
    try {
      commit(
        'setCurrentPage', param
      )
    } catch (e) { throw new Error(e) }
  }
}

const mutations = {
  setUserTableList(state, data) {
    state.userList = data.products
    state.total = data.total
  },
  setCurrentPage(state, data) {
    state.current_page = data
  }
}

export default {
  state,
  actions,
  mutations
}